import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setStoredToken, getStoredToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // null = checking, false = unauthenticated, object = authenticated
    const [user, setUser] = useState(getStoredToken() ? null : false);

    const checkAuth = useCallback(async () => {
        if (!getStoredToken()) {
            setUser(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setStoredToken(null);
            setUser(false);
        }
    }, []);

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.token) setStoredToken(data.token);
        setUser({ id: data.id, email: data.email, name: data.name });
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (_) {
            // ignore
        }
        setStoredToken(null);
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
